import { FC } from "react";
import { CheckboxProps, CHECKBOX_SIZE } from "./types";
import { CheckboxIcon, useCheckboxStyles, useCheckbox } from ".";

const Checkbox: FC<CheckboxProps> = ({
  id,
  selected,
  handleOnChange,
  label,
  size = CHECKBOX_SIZE.LARGE,
  disabled,
  className,
  checkboxClassName,
}) => {
  const { onChangeCheckBox, stopPropagation } = useCheckbox(id, handleOnChange);

  const { containerClassName, inputClassName, labelClassName } =
    useCheckboxStyles(size, selected, disabled, className, checkboxClassName);

  return (
    <div className={containerClassName} onClick={stopPropagation}>
      <div className="relative flex items-center">
        <input
          type="checkbox"
          id={`${id}-checkbox`}
          name="type"
          value={id}
          checked={selected === "checked"}
          onChange={onChangeCheckBox}
          className={inputClassName}
          disabled={disabled}
        />
        <CheckboxIcon selected={selected} />
      </div>
      <label className={labelClassName} htmlFor={`${id}-checkbox`}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
